module.exports = __webpack_public_path__ + "img/72.a86d0dd7.jpg";